import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "inventoryLabResultForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "Inventory ID", required: false },
                model: {
                  value: _vm.inventoryLabResult.inventoryId,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "inventoryId", $$v)
                  },
                  expression: "inventoryLabResult.inventoryId",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Sample Name", required: true },
                model: {
                  value: _vm.inventoryLabResult.sampleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "sampleName", $$v)
                  },
                  expression: "inventoryLabResult.sampleName",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Quality", required: true },
                model: {
                  value: _vm.inventoryLabResult.quality,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "quality", $$v)
                  },
                  expression: "inventoryLabResult.quality",
                },
              }),
              _c(VTextField, {
                attrs: { label: "AveroutN", required: true },
                model: {
                  value: _vm.inventoryLabResult.averoutN,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "averoutN", $$v)
                  },
                  expression: "inventoryLabResult.averoutN",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Program", required: true },
                model: {
                  value: _vm.inventoryLabResult.program,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "program", $$v)
                  },
                  expression: "inventoryLabResult.program",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Technician", required: true },
                model: {
                  value: _vm.inventoryLabResult.technician,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "technician", $$v)
                  },
                  expression: "inventoryLabResult.technician",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Test Time", required: true },
                model: {
                  value: _vm.inventoryLabResult.testTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "testTime", $$v)
                  },
                  expression: "inventoryLabResult.testTime",
                },
              }),
              _c(VCheckbox, {
                attrs: { label: "Final Test" },
                model: {
                  value: _vm.inventoryLabResult.finalTest,
                  callback: function ($$v) {
                    _vm.$set(_vm.inventoryLabResult, "finalTest", $$v)
                  },
                  expression: "inventoryLabResult.finalTest",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }